<script setup>
import {ref, onUnmounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import api from '@/services/api'
import {usePageEditorStore} from '@/stores/pageEditor'

const props = defineProps({
    pageId: Number
})

const route = useRoute()
const router = useRouter()
const pageEditorStore = usePageEditorStore()

const iframe = ref(null)
const iframeSrcdoc = ref('')

const fetchIframeContent = async () => {
    const response = await api.get(`api/page-editor/${props.pageId}`)
    iframeSrcdoc.value = response.data.html
}
fetchIframeContent()

const init = async () => {
    const params = route.params

    await pageEditorStore.init({
        router: router,
        iframe: iframe.value,
        sectionId: parseInt(params.sectionId || 0),
        areaIndex: parseInt(params.areaIndex || -1),
        pageContentId: parseInt(params.pageContentId || 0),
        onSectionDelete: () => {
            router.push({name: 'pageEditor', params: {pageId: props.pageId}})
        }
    })
}

onUnmounted(() => {
    pageEditorStore.unset()
})
</script>

<template>
    <iframe v-if="iframeSrcdoc" ref="iframe" :srcdoc="iframeSrcdoc" @load="init" class="flex-fill"></iframe>
</template>